<template>
  <div id="matchDetail_scheduleDetail">
    <SCHEDULEDETAIL_BASEINFOR
      :CSMeetScheduleInfo="currMatchDetailInfor"
      :themeItem="matchInfo_themeItem"
      @clickPublicThemeEvent="clickPublicThemeEventHandler"
    ></SCHEDULEDETAIL_BASEINFOR>
    <div class="stringSocreExplain">
      <span
        class="noteInfo_item"
        v-for="(item, index) in currMatchDetailInfor.annotation"
        :key="index"
        v-text="`${item.name}：${item.explain}`"
      ></span>
    </div>
    <div class="matchDetail_tab">
      <span
        class="matchResultTabItem"
        v-for="item in matchResultTabArr"
        :key="item.key"
        :class="item.act ? 'act' : ''"
        v-text="item.name"
        @click="clickTab(item)"
      ></span>
    </div>
    <div class="matchDetailDataContainer">
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :isShowAnalysisFlag="isShowAnalysisFlag"
        :localDataProp="localDataProp"
        :startListProp="startListProp"
        :multipleChoiceSharingMenuRow_themeList="themeList"
        :curTimeZoneItem="curTimeZoneItem"
        :sportCompetitionType="sportCompetitionType"
      ></router-view>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
import SCHEDULEDETAIL_BASEINFOR from '@components/platfromBase/compreSportsMeet/scheduleDetail_baseInfor.vue'
import { https_scheduleDetail_matchDetailData } from '@api/platfrom_badminton_api'
import { https_package_getTemplateTypes } from '@api/platfrom_base_api'
export default {
  name: 'matchDetail_scheduleDetail',
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  components: { SCHEDULEDETAIL_BASEINFOR },
  props: {
    // currSportsDetail: {
    //   type: Object,
    //   default: () => ({}),
    // },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    // isRefresh: {
    //   type: Boolean,
    //   default: false,
    // },
    // refreshTime: {
    //   type: Number,
    //   default: 15 * 1000,
    // },
    // pageJumpParams: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   },
    // },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被验证前调用
    // 不能获取组件实例 `this` ！
    // 因为当守卫执行时，组件实例还没被创建！
    console.debug('beforeRouteEnter', from.name, to.name)
    // console.debug('route:', this.$route)
    const currTabPathName = to.name

    next((vm) => {
      vm.matchResultTabArr.forEach((item) => {
        if (item.pathName === currTabPathName) {
          item.act = true
        } else {
          item.act = false
        }
      })
    })
  },
  watch: {
    currSportsDetail: {
      handler(newVal, oldVal) {
        console.debug('scheduleDetail 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.cancelRefreshSetTimeout()
          //   if (newVal.eventId != oldVal.eventId) {
          //     this.currMatch = ''
          //     this.init()
          //   } else
          if (newVal.matchId != oldVal.matchId) {
            // 重新计算需要绘画的视图
            this.eventCompModeObj = null
            this.localDataProp = {
              type: 'localData',
              datas: null,
              isHasData: true,
              eventCompMode: '',
              competitorType: '',
              eventCompModeObj: null,
              isCombatFlag: false,
            }
            this.startListProp = {
              type: 'startList',
              datas: null,
              isHasData: true,
              eventCompMode: '',
              competitorType: '',
              isCombatFlag: false,
            }
          }
        }
      },
      //   immediate: true,
      deep: true,
    },
    $route(to, from) {
      // 监听路由变化，矫正 tab 选中状态
      if (this.matchResultTabArr && this.matchResultTabArr.length > 0) {
        console.debug('$route:', from.name, to.name)
        this.matchResultTabArr.forEach((tabItem) => {
          if (
            `${tabItem.pathName}_${this.getRouterSecPathName()}` === to.name
          ) {
            tabItem.act = true
          } else {
            tabItem.act = false
          }
        })
      }
    },
  },
  data() {
    return {
      refreshTime: 15 * 1000,
      isRefresh: false,
      currSportsDetail: {
        sportsId: null,
        sportsName: null,
        eventId: null,
        eventName: null,
        matchId: null,
      },
      currMatch: '', //首次加载初始化日期
      matchStatusColorArr: [
        {
          colorClass: 'unstart',
          key: ['GETTING_READY', 'SCHEDULED'],
          name: ['已就绪', '按日程计划'],
        },
        {
          colorClass: 'playing',
          key: ['RUNNING', 'SCHEDULED_BREAK'],
          name: ['比赛中', '中场休息'],
        },
        {
          colorClass: 'finished',
          key: ['FINISHED', 'UNSCHEDULED'],
          name: ['已结束', '未安排'],
        },
        {
          colorClass: 'other',
          key: ['CANCELLED', 'DELAYED', 'INTERRUPTED', 'RESCHEDULED'],
          name: ['已取消', '延误', '中断', '推迟', '改期'],
        },
      ],
      resultTypeArr: [
        {
          name: '中间成绩',
          key: 'INTERMEDIATE',
          className: '',
        },
        {
          name: '实时',
          key: 'LIVE',
          className: '',
        },
        {
          name: '官方',
          key: 'OFFICIAL',
          className: '',
        },
        {
          name: '部分成绩',
          key: 'PARTIAL',
          className: '',
        },
        {
          name: '仲裁中',
          key: 'PROTESTED',
          className: '',
        },
        {
          name: '秩序单',
          key: 'START_LIST',
          className: '',
        },
        {
          name: '未确认',
          key: 'UNCONFIRMED',
          className: '',
        },
        {
          name: '非官方',
          key: 'UNOFFICIAL',
          className: '',
        },
      ],
      currResultType: null,
      currMatchDetailInfor: {},
      matchResultTabArr_base: [
        {
          key: 'startList',
          name: '出场名单',
          pathName: 'badmintonScheduleDetailStartList',
          value: '',
          act: true,
        },
        {
          key: 'localData',
          name: '本场数据',
          pathName: 'badmintonScheduleDetailLocalData',
          value: '',
          act: false,
        },
        {
          key: 'dataAnalysis',
          name: '本场数据分析',
          value: '',
          act: false,
          pathName: 'badmintonScheduleDetailDataAnalysis',
        },
      ],
      matchResultTabArr: [],
      localDataProp: {
        type: 'localData',
        datas: null,
        isHasData: true,
        eventCompMode: '',
        competitorType: '',
        eventCompModeObj: null,
        isCombatFlag: false,
      },
      startListProp: {
        type: 'startList',
        datas: null,
        isHasData: true,
        eventCompMode: '',
        competitorType: '',
        eventCompModeObj: null,
        isCombatFlag: false,
      },
      eventCompModeObj: null,
      isShowAnalysisFlag: true,
      refreshId: null,
      themeTemplateType: 31,
      matchInfo_themeItem: null,
      themeList: null,
    }
  },
  created() {
    console.debug(
      'created scheduleDetail:',
      this.currSid,
      this.currSportsDetail,
      this.sportsTypeArr
    )
    const query = this.$route.query
    this.currMatch = query.mid ? query.mid : ''
    if (query.isRefresh) {
      this.isRefresh = query.isRefresh
    }
    if (query.refreshTime) {
      this.refreshTime = query.refreshTime
    }
    this.currSportsDetail = {
      sportsId: query.sportsId,
      sportsName: null,
      eventId: query.eventId,
      eventName: null,
      matchId: query.mid,
    }
    this.pageJumpParams = [query, this.currSportsDetail]
    this.init()
  },
  beforeDestroy() {
    this.cancelRefreshSetTimeout()
  },
  methods: {
    async init() {
      console.debug('this.currMatch:', this.currMatch)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.makeAnalysisItemParams(this.themeTemplateType)
      await this.getMatchDetailData()
      // await this.getTemplateTypes()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'badminton',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0, //this.currSportsDetail.sportsId,
        eid: this.currSportsDetail.eventId,
        pid: 0,
        mid: this.currSportsDetail.matchId,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      // let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = []
        resData.map((item, itemIndex) => {
          // themeAnalysisItemIdArr.push(item.analysisItemId)
          // console.debug(`aa: ${item}`)
          // jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.matchId = this.currSportsDetail.matchId
          item.renderData = null
          if (itemIndex === 0) {
            // 第一个给详情
            this.matchInfo_themeItem = item
          } else {
            // 后2个还放到themeList给阵容
            if (itemIndex === 1) {
              // 单个球队组装2个
              let homeItem = JSON.parse(JSON.stringify(item))
              let awayItem = JSON.parse(JSON.stringify(item))
              const teamList = item.filter.filterTypes[0].values
              homeItem.actJson.teamId = teamList[0].value
              homeItem.analysisItemName = '主队阵容'
              homeItem.twoTitle = '主队阵容'
              awayItem.actJson.teamId = teamList[1].value
              awayItem.analysisItemName = '客队阵容'
              awayItem.twoTitle = '客队阵容'
              this.themeList.push(homeItem)
              this.themeList.push(awayItem)
            } else {
              // 双方球队
              item.twoTitle = item.analysisItemName
              this.themeList.push(item)
            }
          }
          return item
        })
      } else {
        this.themeList = []
        this.matchInfo_themeItem = null
      }
    },
    clickPublicThemeEventHandler(themeItem) {
      this.clickPublicTheme(themeItem)
    },
    refreshSetTimeoutMatchData() {
      //开启定时
      this.cancelRefreshSetTimeout()
      // 开发时，实时刷新功能先关闭
      this.refreshId = setTimeout(() => {
        this.getMatchDetailData()
      }, this.refreshTime)
    },
    cancelRefreshSetTimeout() {
      //取消定时
      if (this.refreshId) {
        clearTimeout(this.refreshId)
      }
    },
    clickTab(tab) {
      let isPageJumpFlag = false
      console.debug(' this.matchResultTabArr:', this.matchResultTabArr)
      this.matchResultTabArr.forEach((item) => {
        if (item.key === tab.key) {
          if (
            !item.act ||
            `${tab.pathName}_${this.currCid}` !== this.$route.name
          ) {
            isPageJumpFlag = true
          }
          item.act = true
        } else {
          item.act = false
        }
      })
      if (isPageJumpFlag) {
        console.debug('this.pageJumpParams:', this.pageJumpParams, tab)
        const [query, params] = this.pageJumpParams
        const pathName =
          typeof tab.pathName === 'string' ? tab.pathName : tab.pathName[0] //数组的话默认返回第一个，第一个是父级
        this.pageJump(
          this.$router,
          `${pathName}_${this.getRouterSecPathName()}`,
          query,
          params
        )
      }
    },
    getRouterSecPathName() {
      let secPathName = ''
      if (this.currThemeObj && this.currThemeObj.moduleRouteNameEn) {
        secPathName = this.currThemeObj.moduleRouteNameEn
      } else {
        console.log('未找到路由')
      }
      return secPathName
    },
    formatMatchStatus(matchStatus) {
      let str = ''
      const num = Number(matchStatus)
      if (num === 1) {
        str = 'SCHEDULED'
      } else if (num === 2) {
        str = 'RUNNING'
      } else if (num === 3) {
        str = 'CANCELLED'
      } else if (num === 4) {
        str = 'FINISHED'
      } else {
      }
      return str
    },
    CSMeetMatchDetailInforFormat(resData) {
      resData.disciplineCode = 'BDM'
      resData.scheduleInfo.scheduleStatus = this.formatMatchStatus(
        resData.scheduleInfo.scheduleStatus - 0
      )
      // resData.scheduleInfo.scheduleStatus = this.formatMatchStatus(1)
      return resData
    },
    renderEventCompModeHanlde(resData) {
      console.debug(
        'renderEventCompModeHanlde:',
        resData,
        this.eventCompModeObj
      )
      let currBigSportsObj = null
      if (this.bigSportsList && resData.disciplineCode) {
        this.bigSportsList.forEach((item) => {
          if (item.id === resData.disciplineCode) {
            currBigSportsObj = item
          }
        })
      }

      // 处理特殊的大项，更换 matchResultTabArr （体操项目）
      let matchResultTabArr = null
      // console.debug('currBigSportsObj2:', currBigSportsObj, this.bigSportsList)
      if (
        currBigSportsObj.routePageArr &&
        currBigSportsObj.routePageArr.length > 0
      ) {
        currBigSportsObj.routePageArr.forEach((routePage, routerIndex) => {
          if (routePage.eventIdArr.includes(this.currSportsDetail.eventId)) {
            matchResultTabArr = routePage.tabArr
          }
          if (
            routerIndex === currBigSportsObj.routePageArr.length - 1 &&
            !matchResultTabArr
          ) {
            matchResultTabArr = routePage.tabArr
          }
        })
        // this.currMatchResultTab_sportsId = currBigSportsObj.id //体操
      } else {
        matchResultTabArr = this.matchResultTabArr_base
      }

      let currTab_key = null
      let sameKeyFlag = false
      let curTabIndex = 0
      console.debug(' this.matchResultTabArr:', this.matchResultTabArr)
      if (this.matchResultTabArr.length > 0) {
        // 不是刷新时，走这里，因为this.matchResultTabArr有值
        this.matchResultTabArr.forEach((item, itemIndex) => {
          if (item.act) {
            currTab_key = item.key
            curTabIndex = itemIndex
          }
        })
      } else if (matchResultTabArr.length > 0) {
        // 是刷新走这里，因为this.matchResultTabArr没值，但matchResultTabArr应该有值
        const pathName = this.$route.name
        matchResultTabArr.forEach((item, itemIndex) => {
          if (pathName === `${item.pathName}_${this.currCid}`) {
            currTab_key = item.key
            sameKeyFlag = true
            item.act = true
            curTabIndex = itemIndex
          } else {
            item.act = false
          }
        })
      } else {
        // 因这里面不能切换大小项，一旦进入赛果 matchResultTabArr 是固定的，固定的所以刷新的时候比如会找相同的tab,出发切换比赛也会引起 matchResultTabArr 的变化，所以不需要走这个逻辑，
        console.error('因为切换比赛，导致matchResultTabArr发生变化')
        // 以防万一，这里可以设置默认为0
        curTabIndex = 0
        // if (!currTab_key) {
        //   curTabIndex = 0 //刷新页面重置到0
        // } else if (matchResultTabArr.length === 2) {
        //   curTabIndex = 0 //跳水 混合团体 tab只有2个【本场数据，数据分析】，因此没找到回到索引0
        // } else {
        //   curTabIndex = 1
        // }
      }
      console.debug(
        'curTabIndex:',
        curTabIndex,
        currTab_key,
        sameKeyFlag,
        matchResultTabArr,
        this.pageJumpParams
      )

      this.matchResultTabArr = JSON.parse(JSON.stringify(matchResultTabArr))
      this.clickTab(matchResultTabArr[curTabIndex])
      console.debug('matchResultTabArr:', matchResultTabArr)

      // 根据对抗和非对抗来设置 startList 和 localData 的视图
      if (currBigSportsObj) {
        let ind = 0
        if (resData.is_confrontational) {
          // 对抗类
          ind = 0
        } else {
          // 非对抗类
          ind = 1
        }
        console.debug(
          ind,
          resData.competitorType,
          currBigSportsObj[this.sportsTypeArr[ind]]
        )
        const eventCompModeArr =
          currBigSportsObj[this.sportsTypeArr[ind]][resData.competitorType]
        if (eventCompModeArr && eventCompModeArr.length === 1) {
          this.eventCompModeObj = eventCompModeArr[0]
        } else {
          // 存在多个视图时，需要过滤
          for (let i = 0; i < eventCompModeArr.length; i++) {
            const modeItem = eventCompModeArr[i]
            console.debug('eventCompModeArr:', modeItem)
            if (
              modeItem.specialEventArr &&
              modeItem.specialEventArr.includes(resData.eventCode)
            ) {
              this.eventCompModeObj = modeItem
              break
            }
            if (!modeItem.specialEventArr) {
              // 上面的都没取到，则取最后一个默认视图
              this.eventCompModeObj = modeItem
            }
          }
        }
      }
      console.debug('this.eventCompModeObj:', this.eventCompModeObj)
      if (resData && resData.resultInfo) {
        // 本场数据  田径 【男子十项全能 |女子七项全能】需要通过 localDataTitleArr 判断
        let eventCompMode = this.lockEventCompMode(
          this.eventCompModeObj,
          'localData',
          resData
        )
        this.localDataProp = {
          type: 'localData',
          datas: resData.resultInfo,
          isHasData: true,
          competitorType: resData.competitorType,
          eventCompMode,
          eventCompModeObj: this.eventCompModeObj,
          isCombatFlag: resData.is_confrontational,
        }
      } else {
        if (!this.localDataProp.datas) {
          // 初次赋值，需要定下视图mode; 没有数据时一直为null；一旦有了数据如果下次更新数据时接口没有给数据，则舍弃这次数据，保留上一次的数据

          // 本场数据  田径 【男子十项全能 |女子七项全能】需要通过 localDataTitleArr 判断
          let eventCompMode = this.lockEventCompMode(
            this.eventCompModeObj,
            'localData',
            resData
          )
          this.localDataProp = {
            type: 'localData',
            datas: null,
            isHasData: false,
            competitorType: resData.competitorType,
            eventCompMode,
            eventCompModeObj: this.eventCompModeObj,
            isCombatFlag: resData.is_confrontational,
          }
        }
      }

      if (resData && resData.startList) {
        // 出场名单 射击 【25米手枪速射 |】
        console.debug('startListTitleArr', this.eventCompModeObj)
        let eventCompMode = this.lockEventCompMode(
          this.eventCompModeObj,
          'startList',
          resData
        )

        this.startListProp = {
          type: 'startList',
          datas: resData.startList,
          isHasData: true,
          competitorType: resData.competitorType,
          eventCompMode,
          eventCompModeObj: this.eventCompModeObj,
          isCombatFlag: resData.is_confrontational,
        }
      } else {
        if (!this.startListProp.datas) {
          // 初次赋值，需要定下视图mode; 没有数据时一直为null；一旦有了数据如果下次更新数据时接口没有给数据，则舍弃这次数据，保留上一次的数据

          // 出场名单 射击 【25米手枪速射 |】
          console.debug('startListTitleArr', this.eventCompModeObj)
          let eventCompMode = this.lockEventCompMode(
            this.eventCompModeObj,
            'startList',
            resData
          )

          this.startListProp = {
            type: 'startList',
            datas: null,
            isHasData: false,
            competitorType: resData.competitorType,
            eventCompMode,
            eventCompModeObj: this.eventCompModeObj,
            isCombatFlag: resData.is_confrontational,
          }
        }
      }
    },
    lockEventCompMode(eventCompModeObj, tabType, resData) {
      const tabKeyArr = ['startList', 'localData']
      let eventCompMode =
        eventCompModeObj && eventCompModeObj[`${tabType}`]
          ? eventCompModeObj[`${tabType}`]
          : ''
      if (eventCompModeObj[`${tabType}TitleArr`]) {
        let flag = false
        eventCompModeObj[`${tabType}TitleArr`].forEach((titleItem) => {
          if (resData.title.indexOf(titleItem) > -1) {
            flag = true
          }
        })
        if (!flag) {
          // 如果不在 `${tabType}TitleArr` 数组中，则取视图默认是视图
          eventCompMode =
            eventCompModeObj.defaultEventCompMode[tabKeyArr.indexOf(tabType)]
        }
      }
      console.debug('eventCompMode:', eventCompMode)
      return eventCompMode
    },
    async getTemplateTypes() {
      await https_package_getTemplateTypes(this.axiosBaseUrl, this.$axios, {
        competitionId: this.currCid,
        seasonId: this.currSid,
        analysisType: '2',
        disciplineId: this.currSportsDetail.sportsId
          ? this.currSportsDetail.sportsId
          : '',
        eventId: this.currSportsDetail.eventId
          ? this.currSportsDetail.eventId
          : '',
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data && res.data.length > 0) {
              // this.themeTemplateType =
              //   res.data[0] && res.data[0].templateType
              //     ? res.data[0].templateType
              //     : null
              this.isShowAnalysisFlag = true
            } else {
              console.debug('暂无数据')
              // this.themeTemplateType = null
              this.isShowAnalysisFlag = false
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getMatchDetailData() {
      await https_scheduleDetail_matchDetailData(
        this.axiosBaseUrl,
        this.$axios,
        {
          sid: this.currSid,
          mid: this.currMatch ? this.currMatch : '',
        }
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              const CSMeetRseData = this.CSMeetMatchDetailInforFormat(res.data)
              // const CSMeetRseData = res.data
              console.debug('CSMeetRseData:', CSMeetRseData)
              // if (flag) {
              //   //测试数据变化
              //   this.renderEventCompModeHanlde({})
              // } else {
              //   this.renderEventCompModeHanlde(res.data)
              // }
              let currResultType = null
              this.resultTypeArr.forEach((typeItem) => {
                if (typeItem.key === CSMeetRseData.result_status) {
                  currResultType = typeItem
                }
              })
              this.currResultType = currResultType

              this.renderEventCompModeHanlde(CSMeetRseData)
              const item = CSMeetRseData.scheduleInfo
              if (item.scheduleCode) {
                let newItem = {}
                newItem.matchTime = item.formatTime
                newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
                newItem.isChina = item.cn
                newItem.isGold = item.medalFlag === '1'
                newItem.type = item.confrontation
                  ? this.sportsTypeArr[0]
                  : this.sportsTypeArr[1]
                newItem.matchId = item.scheduleCode
                // newItem.venueName = item.venueName
                // 拼接场馆（目前只有汤尤杯|苏迪曼杯这类）
                if (item.venueName && item.locationName) {
                  newItem.venueName = `${item.venueName}-${item.locationName}`
                } else {
                  newItem.venueName = `${item.venueName ? item.venueName : ''}${
                    item.locationName ? item.locationName : ''
                  }`
                }
                this.matchStatusColorArr.forEach((statusItem, statusIndex) => {
                  let indexNo = statusItem.key.indexOf(item.scheduleStatus)
                  if (indexNo > -1) {
                    newItem.matchStatus = statusItem.name[indexNo]
                    this.currMatchStatus = statusItem
                  }

                  if (indexNo > -1 && statusIndex === 0) {
                    //比赛未开始；显示比赛日期和时间
                    currResultType = {
                      name: `${item.formatDate} ${item.formatTime}`,
                      key: 'MATCHDATE',
                      className: 'matchDate',
                    }
                  }
                })
                newItem.irm1Result = item.irm1Result
                newItem.irm2Result = item.irm2Result
                newItem.sportsId = item.disciplineCode
                newItem.sportsName = item.disciplineName
                newItem.eventId = item.eventCode
                newItem.eventName = item.eventName
                newItem.scheduleName = item.scheduleName
                newItem.formatDate = item.formatDate
                newItem.formatTime = item.formatTime
                newItem.competitor1Names = item.competitor1Names
                  ? item.competitor1Names.map((ceil) => {
                      return {
                        playerName: ceil.athleteName,
                        playerLogo: ceil.athleteLogo,
                      }
                    })
                  : []
                newItem.competitor2Names = item.competitor2Names
                  ? item.competitor2Names.map((ceil) => {
                      return {
                        playerName: ceil.athleteName,
                        playerLogo: ceil.athleteLogo,
                      }
                    })
                  : []
                newItem.competitorType = item.competitorType
                newItem.medalist = item.medals
                  ? item.medals.map((player, index) => {
                      return {
                        playerId: index + 1,
                        playerName: player.competitorName,
                        medalType: player.medalType,
                        delegationName: player.organisationName,
                        delegationLogo: player.organisationLogo,
                      }
                    })
                  : []

                if (newItem.type === this.sportsTypeArr[0]) {
                  let homeName = '',
                    awayName = ''
                  if (item.competitorType === 'T') {
                    homeName = item.organisation1Name
                    awayName = item.organisation2Name
                  }
                  newItem.homeName = homeName
                  newItem.awayName = awayName

                  newItem.homeScore = item.competitor1Result
                  newItem.awayScore = item.competitor2Result
                }
                newItem.homeLogo = item.organisation1Logo
                newItem.awayLogo = item.organisation2Logo
                newItem.annotation = item.annotation ? item.annotation : []
                newItem.currResultType = currResultType
                this.currMatchDetailInfor = newItem
                console.debug(
                  'this.currMatchDetailInfor:',
                  this.currMatchDetailInfor
                )
              } else {
                // this.currMatchDetailInfor = null
              }
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                duration: 0,
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })

      if (
        this.currMatchStatus &&
        this.currMatchStatus.colorClass === 'playing'
      ) {
        // 比赛进行中 | 中场休息 开启刷新
        this.refreshSetTimeoutMatchData()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#matchDetail_scheduleDetail {
  padding-top: 0.694vw;
  .shedule_date {
    margin-top: 2.778vw;
    width: 100%;
    height: 7.638vw;
  }

  .stringSocreExplain {
    width: 100%;
    height: auto;
    padding: 1.04vw 1.388vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    color: var(--mixtmt_greyColor2);
    .noteInfo_item {
      width: auto;
      min-width: 12.5%;
      padding-right: 1.388vw;
      text-align: left;
      font-size: 0.972vw;
      line-height: 1.11vw;
    }
  }
  .matchDetail_tab {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 3.47vw;
    padding: 0 1.388vw;
    background-color: var(--mixtmt_greyColor7);
    .matchResultTabItem {
      position: relative;
      width: auto;
      height: 3.47vw;
      line-height: 3.47vw;
      margin-right: 4.86vw;
      font-size: 1.25vw;
      font-weight: bold;
      color: var(--mixtmt_blackColor);
      &::before {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 2px;
        background-color: var(--mixtmt_subColor1_1);
      }
      &.act {
        color: var(--mixtmt_subColor1_1);
        &::before {
          content: '\20';
        }
      }
    }
  }

  .matchDetailDataContainer {
    width: 100%;
    min-height: 6.94vw;
  }
}

.mixtmt_pc #matchDetail_scheduleDetail {
  .matchDetail_tab {
    .matchResultTabItem {
      &:hover {
        cursor: pointer;
        color: var(--mixtmt_subColor1_1);
        &::before {
          content: '\20';
        }
      }
    }
  }
}
</style>
